// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "../../controllers/application"

// Import and register all your controllers here
import FileUploadController from "../../cms/controllers/file_upload_controller.js"
application.register("file-upload", FileUploadController)

import VerificationForm from "./verification_form_controller.js"
application.register("verification-form", VerificationForm)

import DropzoneController from '@kanety/stimulus-dropzone';
application.register('dropzone', DropzoneController);

import HiddenContent from '../../helpdesk/shared/hidden_content_controller.js'
application.register('hidden-content', HiddenContent)

import EmbedController from './embed_controller.js'
application.register('embed', EmbedController)